/* eslint-disable arrow-body-style */
// @flow
import React from 'react';
import { t } from 'javascripts/utils/withTranslation';
import HeaderIcon from './HeaderIcon';

type Props = {
  link: string,
  label?: string,
  tooltip?: string,
};

const BurgerFallBack = ({
  link,
  label,
  tooltip,
}: Props): React$MixedElement => {
  return (
    <HeaderIcon
      link={link}
      icon="burger-menu"
      label={label || t('Menü')}
      labelId="header-icon-label--burger"
      tooltip={tooltip || t('Menü')}
    />
  );
};

export default BurgerFallBack;
